import { useTranslation } from "react-i18next";

const ROW_KEYS = [
  "afterHours",
  "quote",
  "burst",
  "weekend",
  "pricelist",
  "competition",
] as const;

function CrossIcon(): JSX.Element {
  return (
    <svg
      className="ico"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function CheckIcon(): JSX.Element {
  return (
    <svg
      className="ico"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--accent)"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function PlatformCompare(): JSX.Element {
  const { t } = useTranslation("common");

  // The id is an anchor target, not decoration: ``/vs-marketplaces``
  // sends the reader here rather than repeating this table, and a
  // second copy of it would drift from this one within a release.
  return (
    <section id="platform-compare" className="section alt center">
      <div className="inner narrow">
        <p className="kicker">{t("platformLanding.compare.kicker")}</p>
        <h2 className="h2">{t("platformLanding.compare.heading")}</h2>

        <div className="compare" data-testid="platform-compare">
          <div className="c-row head">
            <div>{t("platformLanding.compare.colSituation")}</div>
            <div>{t("platformLanding.compare.colToday")}</div>
            <div className="s">{t("platformLanding.compare.colWith")}</div>
          </div>
          {ROW_KEYS.map((key) => (
            <div key={key} className="c-row">
              <div className="c-task">
                {t(`platformLanding.compare.rows.${key}.task`)}
              </div>
              <div className="c-cell">
                <CrossIcon />
                <span>{t(`platformLanding.compare.rows.${key}.today`)}</span>
              </div>
              <div className="c-cell s">
                <CheckIcon />
                <span>{t(`platformLanding.compare.rows.${key}.with`)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
